import { CREATE_KEYWORDS_REQUEST, CREATE_KEYWORDS_REQUEST_FAILURE, CREATE_KEYWORDS_REQUEST_SUCCESS, DELETE_KEYWORDS_REQUEST, DELETE_KEYWORDS_REQUEST_FAILURE, DELETE_KEYWORDS_REQUEST_SUCCESS, FETCH_CHABOT_REPORT_DATA, FETCH_CHABOT_REPORT_DATA_FAILURE, FETCH_CHABOT_REPORT_DATA_SUCCESS, FETCH_KM_SOURCE_DATA, FETCH_KM_SOURCE_DATA_FAILURE, FETCH_KM_SOURCE_DATA_SUCCESS, GET_KEYWORDS_REQUEST, GET_KEYWORDS_REQUEST_FAILURE, GET_KEYWORDS_REQUEST_SUCCESS, UPDATE_KM_SOURCE_DATA, UPDATE_KM_SOURCE_DATA_FAILURE, UPDATE_KM_SOURCE_DATA_SUCCESS } from "../actions/aiChatbot.actions";

const initialState = {
    exceptionalData: {
        loading: false,
        keywords: [],
        error: null,
    },
    reportData: {
        loading: false,
        data: [],
        pagination: {
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 0
        },
        error: null,
    },
    kmSourceData: {
        loading: false,
        data: [],
        pagination: {
            page: 1,
            limit: 10,
            total: 0,
            totalPages: 0
        },
        error: null,
    },
};

export function aiChatbot(state = initialState, action) {
    switch (action.type) {
        case GET_KEYWORDS_REQUEST:
        case CREATE_KEYWORDS_REQUEST:
        case DELETE_KEYWORDS_REQUEST:
            return {
                ...state,
                exceptionalData: {
                    ...state.exceptionalData,
                    loading: true,
                    error: null,
                }
            };
        case FETCH_CHABOT_REPORT_DATA:
            return {
                ...state,
                reportData: {
                    ...state.reportData,
                    loading: true,
                    error: null,
                }
            }
        case FETCH_KM_SOURCE_DATA:
        case UPDATE_KM_SOURCE_DATA:
            return {
                ...state,
                kmSourceData: {
                    ...state.kmSourceData,
                    loading: true,
                    error: null,
                }
            }
        case GET_KEYWORDS_REQUEST_SUCCESS:
            return {
                ...state,
                exceptionalData: {
                    ...state.exceptionalData,
                    loading: false,
                    keywords: action.payload || [],
                    error: null,
                }
            };
        case CREATE_KEYWORDS_REQUEST_SUCCESS:
            return {
                ...state,
                exceptionalData: {
                    ...state.exceptionalData,
                    loading: false,
                    keywords: [action.payload, ...state.exceptionalData.keywords],
                    error: null,
                }
            };
        case DELETE_KEYWORDS_REQUEST_SUCCESS:
            return {
                ...state,
                exceptionalData: {
                    ...state.exceptionalData,
                    loading: false,
                    keywords: state.exceptionalData.keywords.filter(
                        (kw) => kw._id !== action.payload.id
                    ),
                    error: null,
                }
            };
        case FETCH_CHABOT_REPORT_DATA_SUCCESS:
            return {
                ...state,
                reportData: {
                    ...state.reportData,
                    data: action.payload?.data,
                    pagination: {
                        page: action.payload?.page,
                        limit: action.payload?.limit,
                        total: action.payload?.total,
                        totalPages: action.payload?.totalPages,
                    },
                    loading: false,
                    error: null,
                }
            }
        case FETCH_KM_SOURCE_DATA_SUCCESS:
            return {
                ...state,
                kmSourceData: {
                    ...state.kmSourceData,
                    data: action.payload?.data,
                    pagination: {
                        page: action.payload?.page,
                        limit: action.payload?.limit,
                        total: action.payload?.total,
                        totalPages: action.payload?.totalPages,
                    },
                    loading: false,
                    error: null,
                }
            }
        case UPDATE_KM_SOURCE_DATA_SUCCESS:
            return {
                ...state,
                kmSourceData: {
                    ...state.kmSourceData,
                    data: state.kmSourceData.data.map((km) => km._id === action.payload._id ? { ...km, ...action.payload } : km),
                    loading: false,
                    error: null,
                }
            }
        case GET_KEYWORDS_REQUEST_FAILURE:
        case CREATE_KEYWORDS_REQUEST_FAILURE:
        case DELETE_KEYWORDS_REQUEST_FAILURE:
            return {
                ...state,
                exceptionalData: {
                    ...state.exceptionalData,
                    loading: false,
                    error: action.error,
                }
            };
        case FETCH_CHABOT_REPORT_DATA_FAILURE:
            return {
                ...state,
                reportData: {
                    ...state.reportData,
                    loading: false,
                    error: action.error
                }
            };
        case FETCH_KM_SOURCE_DATA_FAILURE:
        case UPDATE_KM_SOURCE_DATA_FAILURE:
            return {
                ...state,
                kmSourceData: {
                    ...state.kmSourceData,
                    loading: false,
                    error: action.error
                }
            };
        default:
            return state;
    }
};